import 'react-notifications/lib/notifications.css'
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import { NotificationContainer, NotificationManager } from 'react-notifications'
import { Buffer } from 'buffer'
import { FaImage, FaVideo, FaPlus, FaCheck, FaTimes, FaEdit } from "react-icons/fa"
import AdminLayout from "../../../components/AdminLayout"

//Components
import GameService from "../../../services/game_services"

class AdminTips extends Component {
    constructor(props) {
        super(props)
        this.state = {
            tips: [],
            deactivated: false,
            selectKey: null,
            order: 'asc',
            selected: [],
            processing: false,
            title: "",
            description: "",
            view_weight: "",
            imgData: null,
            imgSize: 0,
            imgExtension: null,
            videoData: null,
            videoSize: 0,
            videoExtension: null,
            showUpdateModal: false,
            edit_tutorial_uuid: null,
            edit_title: "",
            edit_description: "",
            edit_view_weight: "",
            edit_imgData: null,
            edit_videoData: null,
        }
    }

    componentDidMount = async () => {
        await this.loadTips()
    }

    loadTips = async () => {
        const tips = await GameService.getTips(this.state.deactivated)
        this.setState({ tips })
    }

    reorder = async (key) => {
        let order = 'asc'
        if (this.state.selectKey === key && this.state.order === 'asc')
            order = 'desc'
        this.setState({ selectKey: key, order })
        let tips = this.state.tips
        
        // Check if sorting by date field
        const dateFields = ['created_date', 'updated_date']
        if (dateFields.includes(key)) {
            if (order === 'asc')
                tips.sort((a, b) => new Date(a[key] || 0) - new Date(b[key] || 0))
            else
                tips.sort((a, b) => new Date(b[key] || 0) - new Date(a[key] || 0))
        } else {
            if (order === 'asc')
                tips.sort((a, b) => (a[key] > b[key]) ? 1 : ((b[key] > a[key]) ? -1 : 0))
            else
                tips.sort((a, b) => (a[key] < b[key]) ? 1 : ((b[key] < a[key]) ? -1 : 0))
        }
        this.setState({ tips })
    }

    createNewTips = async () => {
        if (window.confirm("Do you confirm tips creation?")) {
            this.setState({ processing: true })
            await GameService.createTip(this.state.title, this.state.description, this.state.imgData, this.state.videoData, this.state.view_weight)
            NotificationManager.success('Tips created')
            await this.loadTips()
            this.setState({ processing: false })
        }
    }

    onImgHandler = async (event) => {
        const reader = new FileReader()
        const extension = event.target.files[0] && event.target.files[0].name.split('.').pop().toLowerCase()
        if (!extension || !['jpeg', 'jpg', 'png'].includes(extension)) {
            NotificationManager.error('Invalid file')
        } else if (event.target.files[0].size > 5000000) {
            NotificationManager.error('File exceeding 5Mo')
        } else {
            await this.setState({ imgSize: event.target.files[0].size, imgExtension: extension })
            reader.onloadend = () => this.processImg(reader)
            reader.readAsArrayBuffer(event.target.files[0])
        }
    }

    processImg = async (reader) => {
        const buffer = Buffer.from(reader.result)
        const base64data = buffer.toString('base64')
        this.setState({ imgData: `data:image/${this.state.imgExtension};base64,${base64data}` })
    }

    onVideoHandler = async (event) => {
        const reader = new FileReader()
        const extension = event.target.files[0] && event.target.files[0].name.split('.').pop().toLowerCase()
        if (!extension || !['mp4'].includes(extension)) {
            NotificationManager.error('Invalid file')
        } else if (event.target.files[0].size > 5000000) {
            NotificationManager.error('File exceeding 5Mo')
        } else {
            await this.setState({ videoSize: event.target.files[0].size, videoExtension: extension })
            reader.onloadend = () => this.processVideo(reader)
            reader.readAsArrayBuffer(event.target.files[0])
        }
    }

    processVideo = async (reader) => {
        const buffer = Buffer.from(reader.result)
        const base64data = buffer.toString('base64')
        this.setState({ videoData: `data:video/${this.state.videoExtension};base64,${base64data}` })
    }

    activateTip = async (tutorial_uuid) => {
        await GameService.activateTip(tutorial_uuid)
        this.loadTips()
    }

    deactivateTip = async (tutorial_uuid) => {
        await GameService.deactivateTip(tutorial_uuid)
        this.loadTips()
    }

    openUpdateModal = (tip) => {
        this.setState({
            showUpdateModal: true,
            edit_tutorial_uuid: tip.tutorial_uuid,
            edit_title: tip.title || "",
            edit_description: tip.description || "",
            edit_view_weight: tip.view_weight ?? "",
            edit_imgData: null,
            edit_videoData: null,
        })
    }

    closeUpdateModal = () => {
        this.setState({
            showUpdateModal: false,
            edit_tutorial_uuid: null,
            edit_title: "",
            edit_description: "",
            edit_view_weight: "",
            edit_imgData: null,
            edit_videoData: null,
        })
    }

    onEditImgHandler = async (event) => {
        const reader = new FileReader()
        const extension = event.target.files[0] && event.target.files[0].name.split('.').pop().toLowerCase()
        if (!extension || !['jpeg', 'jpg', 'png'].includes(extension)) {
            NotificationManager.error('Invalid file')
        } else if (event.target.files[0].size > 5000000) {
            NotificationManager.error('File exceeding 5Mo')
        } else {
            await this.setState({ imgExtension: extension })
            reader.onloadend = () => this.processEditImg(reader)
            reader.readAsArrayBuffer(event.target.files[0])
        }
    }

    processEditImg = async (reader) => {
        const buffer = Buffer.from(reader.result)
        const base64data = buffer.toString('base64')
        this.setState({ edit_imgData: `data:image/${this.state.imgExtension};base64,${base64data}` })
    }

    onEditVideoHandler = async (event) => {
        const reader = new FileReader()
        const extension = event.target.files[0] && event.target.files[0].name.split('.').pop().toLowerCase()
        if (!extension || !['mp4'].includes(extension)) {
            NotificationManager.error('Invalid file')
        } else if (event.target.files[0].size > 5000000) {
            NotificationManager.error('File exceeding 5Mo')
        } else {
            await this.setState({ videoExtension: extension })
            reader.onloadend = () => this.processEditVideo(reader)
            reader.readAsArrayBuffer(event.target.files[0])
        }
    }

    processEditVideo = async (reader) => {
        const buffer = Buffer.from(reader.result)
        const base64data = buffer.toString('base64')
        this.setState({ edit_videoData: `data:video/${this.state.videoExtension};base64,${base64data}` })
    }

    updateTip = async () => {
        if (window.confirm("Do you confirm tip update?")) {
            this.setState({ processing: true })
            const updateData = {}
            if (this.state.edit_title) updateData.title = this.state.edit_title
            if (this.state.edit_description) updateData.description = this.state.edit_description
            if (this.state.edit_view_weight !== "") updateData.view_weight = Number(this.state.edit_view_weight)
            if (this.state.edit_imgData) updateData.picture = this.state.edit_imgData
            if (this.state.edit_videoData) updateData.video = this.state.edit_videoData
            
            await GameService.updateTip(this.state.edit_tutorial_uuid, updateData)
            NotificationManager.success('Tip updated')
            this.closeUpdateModal()
            await this.loadTips()
            this.setState({ processing: false })
        }
    }

    render() {
        return (
            <>
                <AdminLayout 
                    title="Tips Management"
                    breadcrumbs={[{ label: 'Tips' }]}
                >
                    <div className="space-y-6">
                        {/* Create New Tip Form */}
                        <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl p-6 border border-blue-200">
                            <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
                                <FaPlus className="text-blue-600" />
                                Create New Tip
                            </h3>
                            
                            {this.state.processing ? (
                                <div className="text-center py-4">
                                    <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
                                    <p className="text-gray-600 mt-2">Processing... please wait</p>
                                </div>
                            ) : (
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div className="space-y-4">
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">Title</label>
                                            <input 
                                                type="text" 
                                                placeholder="Enter tip title" 
                                                value={this.state.title} 
                                                onChange={(e) => this.setState({ title: e.target.value })}
                                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none"
                                            />
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">Description</label>
                                            <textarea 
                                                placeholder="Enter tip description" 
                                                value={this.state.description} 
                                                onChange={(e) => this.setState({ description: e.target.value })}
                                                rows="3"
                                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none resize-none"
                                            />
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">View weight (optional)</label>
                                            <input
                                                type="number"
                                                placeholder="Display priority"
                                                value={this.state.view_weight}
                                                onChange={(e) => this.setState({ view_weight: e.target.value })}
                                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none"
                                            />
                                        </div>
                                    </div>
                                    <div className="space-y-4">
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                                                <FaImage /> Image (max 5MB)
                                            </label>
                                            <input 
                                                type="file" 
                                                onChange={(e) => this.onImgHandler(e)} 
                                                accept="image/*"
                                                className="w-full text-sm text-gray-600 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:bg-blue-100 file:text-blue-700 hover:file:bg-blue-200 file:cursor-pointer"
                                            />
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                                                <FaVideo /> Video (max 5MB)
                                            </label>
                                            <input 
                                                type="file" 
                                                onChange={(e) => this.onVideoHandler(e)} 
                                                accept="video/mp4"
                                                className="w-full text-sm text-gray-600 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:bg-blue-100 file:text-blue-700 hover:file:bg-blue-200 file:cursor-pointer"
                                            />
                                        </div>
                                        <button 
                                            onClick={this.createNewTips}
                                            className="w-full bg-gradient-to-r from-blue-500 to-indigo-600 text-white py-2 rounded-lg hover:from-blue-600 hover:to-indigo-700 transition-all font-medium shadow-md hover:shadow-lg flex items-center justify-center gap-2"
                                        >
                                            <FaPlus />
                                            Create Tip
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* Filter Toggle */}
                        <div className="flex justify-between items-center">
                            <h3 className="text-lg font-semibold text-gray-900">
                                {this.state.deactivated ? 'Deactivated' : 'Active'} Tips
                            </h3>
                            <button
                                onClick={() => this.setState({ deactivated: !this.state.deactivated }, () => this.loadTips())}
                                className={`px-4 py-2 rounded-lg font-medium transition-all ${
                                    this.state.deactivated
                                        ? 'bg-green-100 text-green-700 hover:bg-green-200'
                                        : 'bg-red-100 text-red-700 hover:bg-red-200'
                                }`}
                            >
                                {this.state.deactivated ? 'Show Active' : 'Show Deactivated'}
                            </button>
                        </div>

                        {/* Tips Table */}
                        <div className="overflow-x-auto bg-white rounded-xl border border-gray-200">
                            <table className="w-full">
                                <thead className="bg-gray-50 border-b border-gray-200">
                                    <tr>
                                        <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">#</th>
                                        <th 
                                            className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase cursor-pointer hover:bg-gray-100"
                                            onClick={() => this.reorder("title")}
                                        >
                                            Title ⥃
                                        </th>
                                        <th 
                                            className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase cursor-pointer hover:bg-gray-100"
                                            onClick={() => this.reorder("created_date")}
                                        >
                                            Created ⥃
                                        </th>
                                        <th 
                                            className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase cursor-pointer hover:bg-gray-100"
                                            onClick={() => this.reorder("view_weight")}
                                        >
                                            Weight ⥃
                                        </th>
                                        <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Description</th>
                                        <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Media</th>
                                        <th className="px-4 py-3 text-center text-xs font-semibold text-gray-600 uppercase">Actions</th>
                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-200">
                                    {this.state.tips.map((tip, index) => (
                                        <tr key={`tip_${tip.marketing_tip_uuid}`} className="hover:bg-gray-50 transition-colors">
                                            <td className="px-4 py-4 text-sm font-medium text-gray-900">{index + 1}</td>
                                            <td className="px-4 py-4 text-sm font-medium text-gray-900">{tip.title}</td>
                                            <td className="px-4 py-4 text-sm text-gray-600">
                                                {new Date(tip.created_date).toLocaleDateString()}
                                            </td>
                                            <td className="px-4 py-4 text-sm text-gray-600">{tip.view_weight ?? '-'}</td>
                                            <td className="px-4 py-4 text-sm text-gray-600 max-w-xs truncate">
                                                {tip.description || '-'}
                                            </td>
                                            <td className="px-4 py-4">
                                                <div className="flex gap-2">
                                                    {tip.picture && (
                                                        <img src={tip.picture} alt="Tip" className="w-20 h-20 object-cover rounded-lg border border-gray-200" />
                                                    )}
                                                    {tip.video && (
                                                        <video src={tip.video} className="w-20 h-20 object-cover rounded-lg border border-gray-200" />
                                                    )}
                                                    {!tip.picture && !tip.video && (
                                                        <span className="text-sm text-gray-400">No media</span>
                                                    )}
                                                </div>
                                            </td>
                                            <td className="px-4 py-4 text-center">
                                                <div className="flex justify-center gap-2">
                                                    <button 
                                                        onClick={() => this.openUpdateModal(tip)}
                                                        className="inline-flex items-center gap-2 px-3 py-1.5 bg-blue-100 text-blue-700 rounded-lg hover:bg-blue-200 transition-colors text-sm font-medium"
                                                    >
                                                        <FaEdit /> Edit
                                                    </button>
                                                    {!tip.deactivated ? (
                                                        <button 
                                                            onClick={() => this.deactivateTip(tip.tutorial_uuid)}
                                                            className="inline-flex items-center gap-2 px-3 py-1.5 bg-red-100 text-red-700 rounded-lg hover:bg-red-200 transition-colors text-sm font-medium"
                                                        >
                                                            <FaTimes /> Deactivate
                                                        </button>
                                                    ) : (
                                                        <button 
                                                            onClick={() => this.activateTip(tip.tutorial_uuid)}
                                                            className="inline-flex items-center gap-2 px-3 py-1.5 bg-green-100 text-green-700 rounded-lg hover:bg-green-200 transition-colors text-sm font-medium"
                                                        >
                                                            <FaCheck /> Activate
                                                        </button>
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </AdminLayout>

                {/* Update Tip Modal */}
                {this.state.showUpdateModal && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
                        <div className="bg-white rounded-xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
                            <div className="sticky top-0 bg-gradient-to-r from-blue-500 to-indigo-600 text-white px-6 py-4 rounded-t-xl flex justify-between items-center">
                                <h3 className="text-xl font-semibold flex items-center gap-2">
                                    <FaEdit /> Update Tip
                                </h3>
                                <button
                                    onClick={this.closeUpdateModal}
                                    className="text-white hover:bg-white hover:bg-opacity-20 rounded-lg p-2 transition-colors"
                                >
                                    <FaTimes size={20} />
                                </button>
                            </div>

                            <div className="p-6 space-y-4">
                                {this.state.processing ? (
                                    <div className="text-center py-8">
                                        <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
                                        <p className="text-gray-600 mt-4">Updating tip... please wait</p>
                                    </div>
                                ) : (
                                    <>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">Title (optional)</label>
                                            <input 
                                                type="text" 
                                                placeholder="Enter tip title" 
                                                value={this.state.edit_title} 
                                                onChange={(e) => this.setState({ edit_title: e.target.value })}
                                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none"
                                            />
                                        </div>
                                        
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">Description (optional)</label>
                                            <textarea 
                                                placeholder="Enter tip description" 
                                                value={this.state.edit_description} 
                                                onChange={(e) => this.setState({ edit_description: e.target.value })}
                                                rows="4"
                                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none resize-none"
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">View weight (optional)</label>
                                            <input
                                                type="number"
                                                placeholder="Display priority"
                                                value={this.state.edit_view_weight}
                                                onChange={(e) => this.setState({ edit_view_weight: e.target.value })}
                                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none"
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                                                <FaImage /> New Image (optional, max 5MB)
                                            </label>
                                            <input 
                                                type="file" 
                                                onChange={(e) => this.onEditImgHandler(e)} 
                                                accept="image/*"
                                                className="w-full text-sm text-gray-600 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:bg-blue-100 file:text-blue-700 hover:file:bg-blue-200 file:cursor-pointer"
                                            />
                                            {this.state.edit_imgData && (
                                                <div className="mt-2">
                                                    <img src={this.state.edit_imgData} alt="Preview" className="w-32 h-32 object-cover rounded-lg border border-gray-200" />
                                                </div>
                                            )}
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                                                <FaVideo /> New Video (optional, max 5MB)
                                            </label>
                                            <input 
                                                type="file" 
                                                onChange={(e) => this.onEditVideoHandler(e)} 
                                                accept="video/mp4"
                                                className="w-full text-sm text-gray-600 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:bg-blue-100 file:text-blue-700 hover:file:bg-blue-200 file:cursor-pointer"
                                            />
                                            {this.state.edit_videoData && (
                                                <div className="mt-2">
                                                    <video src={this.state.edit_videoData} className="w-32 h-32 object-cover rounded-lg border border-gray-200" controls />
                                                </div>
                                            )}
                                        </div>

                                        <div className="flex gap-3 pt-4">
                                            <button
                                                onClick={this.updateTip}
                                                className="flex-1 bg-gradient-to-r from-blue-500 to-indigo-600 text-white py-3 rounded-lg hover:from-blue-600 hover:to-indigo-700 transition-all font-medium shadow-md hover:shadow-lg flex items-center justify-center gap-2"
                                            >
                                                <FaCheck /> Update Tip
                                            </button>
                                            <button
                                                onClick={this.closeUpdateModal}
                                                className="px-6 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-all font-medium flex items-center justify-center gap-2"
                                            >
                                                <FaTimes /> Cancel
                                            </button>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                )}

                <NotificationContainer />
            </>
        )
    }
}

export default withTranslation()(AdminTips)